"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9921],{

/***/ 75554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ MutationButton; },
/* harmony export */   "t": function() { return /* binding */ MutationIconButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59106);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78344);
/* harmony import */ var _mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57077);
/* harmony import */ var _mui_material_Fab__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65680);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14724);
/* harmony import */ var _mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8942);
/* harmony import */ var _mui_material_colors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21955);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99109);












var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .ZL)()(function(theme) {
    return {
        buttonMutationLoading: {
            marginRight: theme.spacing(1),
            marginTop: "-2px"
        },
        buttonMutationWithIconLoading: {
            position: "absolute",
            left: "5px"
        },
        iconButtonMutationLoading: {
            marginTop: theme.spacing(0.5),
            marginLeft: "auto",
            marginRight: "auto",
            position: "absolute",
            left: "0",
            right: "0"
        },
        addCustomColor: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.getContrastText(theme.palette.error.main),
            "&:hover": {
                backgroundColor: theme.palette.error.main
            }
        },
        addIconCustomColor: {
            color: theme.palette.error.main
        }
    };
});
var MutationButton = function(_param) {
    var children = _param.children, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _tooltipPlacement = _param.tooltipPlacement, tooltipPlacement = _tooltipPlacement === void 0 ? "top" : _tooltipPlacement, _tooltipMsg = _param.tooltipMsg, tooltipMsg = _tooltipMsg === void 0 ? "" : _tooltipMsg, _tooltipMsgDisabled = _param.tooltipMsgDisabled, tooltipMsgDisabled = _tooltipMsgDisabled === void 0 ? "" : _tooltipMsgDisabled, spanClass = _param.spanClass, loading = _param.loading, onClick = _param.onClick, loadingColor = _param.loadingColor, withIcon = _param.withIcon, variant = _param.variant, overrideProgressStyle = _param.overrideProgressStyle, isRed = _param.isRed, color = _param.color, muiVariant = _param.muiVariant, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "disabled",
        "tooltipPlacement",
        "tooltipMsg",
        "tooltipMsgDisabled",
        "spanClass",
        "loading",
        "onClick",
        "loadingColor",
        "withIcon",
        "variant",
        "overrideProgressStyle",
        "isRed",
        "color",
        "muiVariant"
    ]);
    var classes = useStyles().classes;
    var ButtonComponent = variant === "fab" ? _mui_material_Fab__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z : variant === "icon" ? _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z : _mui_material_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        placement: tooltipPlacement,
        title: disabled ? tooltipMsgDisabled : tooltipMsg,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "".concat(isRed ? classes.addIconCustomColor : "", " ").concat(spanClass),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ButtonComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, rest), {
                color: color !== null && color !== void 0 ? color : isRed ? "inherit" : "primary",
                disabled: disabled || loading,
                onClick: function(e) {
                    return !disabled && (onClick === null || onClick === void 0 ? void 0 : onClick(e));
                },
                variant: muiVariant,
                children: [
                    loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        size: withIcon ? 32 : 18,
                        className: "".concat(classes.buttonMutationLoading, " ").concat(withIcon ? classes.buttonMutationWithIconLoading : ""),
                        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                            color: loadingColor !== null && loadingColor !== void 0 ? loadingColor : _mui_material_colors__WEBPACK_IMPORTED_MODULE_11__/* ["default"][500] */ .Z[500]
                        }, overrideProgressStyle !== null && overrideProgressStyle !== void 0 ? overrideProgressStyle : {})
                    }),
                    children
                ]
            }))
        })
    });
};
/**
 * Quickly set up an `IconButton` wrapped in a `Tooltip` for displaying a message when it's disabled.
 *
 * If a disabled prop has been passed, this will also make sure to block any onClick action, while
 * it is disabled.
 *
 * If a loading prop is passed in, it will automatically handle adding and removing loading spinner
 * around the icon.
 */ var MutationIconButton = function(_param) {
    var children = _param.children, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _tooltipPlacement = _param.tooltipPlacement, tooltipPlacement = _tooltipPlacement === void 0 ? "top" : _tooltipPlacement, _tooltipMsg = _param.tooltipMsg, tooltipMsg = _tooltipMsg === void 0 ? "" : _tooltipMsg, _tooltipMsgDisabled = _param.tooltipMsgDisabled, tooltipMsgDisabled = _tooltipMsgDisabled === void 0 ? "" : _tooltipMsgDisabled, spanClass = _param.spanClass, loading = _param.loading, onClick = _param.onClick, loadingColor = _param.loadingColor, overrideProgressStyle = _param.overrideProgressStyle, isRed = _param.isRed, color = _param.color, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "disabled",
        "tooltipPlacement",
        "tooltipMsg",
        "tooltipMsgDisabled",
        "spanClass",
        "loading",
        "onClick",
        "loadingColor",
        "overrideProgressStyle",
        "isRed",
        "color"
    ]);
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        placement: tooltipPlacement,
        title: disabled ? tooltipMsgDisabled : tooltipMsg,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: "".concat(isRed ? classes.addIconCustomColor : "", " ").concat(spanClass),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                    color: color !== null && color !== void 0 ? color : isRed ? "inherit" : "primary"
                }, rest), {
                    disabled: disabled || loading,
                    onClick: function(e) {
                        return !disabled && (onClick === null || onClick === void 0 ? void 0 : onClick(e));
                    },
                    size: "large",
                    children: children
                })),
                loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    size: 40,
                    className: classes.iconButtonMutationLoading,
                    style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        color: loadingColor !== null && loadingColor !== void 0 ? loadingColor : _mui_material_colors__WEBPACK_IMPORTED_MODULE_11__/* ["default"][500] */ .Z[500]
                    }, overrideProgressStyle !== null && overrideProgressStyle !== void 0 ? overrideProgressStyle : {})
                })
            ]
        })
    });
};


/***/ }),

/***/ 77811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(78344);
/* harmony import */ var _mui_material_Dialog__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67844);
/* harmony import */ var _mui_material_DialogActions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30509);
/* harmony import */ var _mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26561);
/* harmony import */ var _mui_material_DialogContentText__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82063);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89928);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62690);












var DiscardChangesDialog = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(DiscardChangesDialog, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(DiscardChangesDialog);
    function DiscardChangesDialog() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, DiscardChangesDialog);
        var _this;
        _this = _super.apply(this, arguments);
        _this.onDiscard = function() {
            return _this.props.handleResponse(true);
        };
        _this.onSave = function() {
            return _this.props.handleResponse(false);
        };
        return _this;
    }
    var _proto = DiscardChangesDialog.prototype;
    _proto.render = function render() {
        var _props = this.props, t = _props.t, open = _props.open;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Dialog__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                open: open,
                onClose: this.onDiscard,
                "aria-labelledby": "alert-dialog-title",
                "aria-describedby": "alert-dialog-description",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogContentText__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: "alert-dialog-description",
                            children: t([
                                "shared:discardMessage"
                            ], {
                                defaultValue: "You have unsaved changes. Are you sure you want to close?"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_DialogActions__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                onClick: this.onDiscard,
                                color: "primary",
                                children: t([
                                    "shared:discard"
                                ], {
                                    defaultValue: "Discard"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                onClick: this.onSave,
                                color: "primary",
                                autoFocus: true,
                                children: t([
                                    "shared:save"
                                ], {
                                    defaultValue: "Save"
                                })
                            })
                        ]
                    })
                ]
            })
        });
    };
    return DiscardChangesDialog;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_2__/* .compose */ .qC)((0,react_i18next__WEBPACK_IMPORTED_MODULE_11__/* .withTranslation */ .Z)([
    "shared"
]));
/* harmony default export */ __webpack_exports__["Z"] = (enhance(DiscardChangesDialog));


/***/ }),

/***/ 12780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ SelectValidator; },
/* harmony export */   "BV": function() { return /* binding */ MultiSelectWithSearchValidator; },
/* harmony export */   "nn": function() { return /* binding */ SelectWithSearchValidator; }
/* harmony export */ });
/* unused harmony export WrapValidator */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59106);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(48417);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_FilledInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15686);
/* harmony import */ var _mui_material_FormControl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91697);
/* harmony import */ var _mui_material_FormHelperText__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(172);
/* harmony import */ var _mui_material_Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85498);
/* harmony import */ var _mui_material_InputLabel__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(49653);
/* harmony import */ var _mui_material_OutlinedInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3776);
/* harmony import */ var _mui_material_TextField__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(96620);
/* harmony import */ var _mui_material_Autocomplete__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(43964);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(14517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var react_form_validator_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8081);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62690);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(5887);
/* eslint-disable max-classes-per-file */ 




















var inputVariantComponent = {
    standard: _mui_material_Input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
    filled: _mui_material_FilledInput__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
    outlined: _mui_material_OutlinedInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z
};
var styles = function() {
    return {
        star: {
            "&:after": {
                content: "' *'"
            }
        }
    };
};
// tslint:disable:max-classes-per-file
var InputValidator = /*#__PURE__*/ function(ValidatorComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(InputValidator, ValidatorComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(InputValidator);
    function InputValidator() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(this, InputValidator);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            isValid: true
        };
        return _this;
    }
    var _proto = InputValidator.prototype;
    _proto.render = function render() {
        var _props = this.props, errorMessages = _props.errorMessages, _validators = _props.validators, validators = _validators === void 0 ? [] : _validators, containerClass = _props.containerClass, requiredError = _props.requiredError, helperText = _props.helperText, inputLabelProps = _props.inputLabelProps, label = _props.label, validatorListener = _props.validatorListener, onKeyPress = _props.onKeyPress, variant = _props.variant, propLabelWidth = _props.labelWidth, classes = _props.classes, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_props, [
            "errorMessages",
            "validators",
            "containerClass",
            "requiredError",
            "helperText",
            "inputLabelProps",
            "label",
            "validatorListener",
            "onKeyPress",
            "variant",
            "labelWidth",
            "classes"
        ]);
        var labelWidth = propLabelWidth;
        var isValid = this.state.isValid;
        // Unless overridden, we disable enter key in the input.
        var defaultKeyPress = function(ev) {
            if (ev.key === "Enter") {
                ev.preventDefault();
            }
        };
        var useOnKeyPress = defaultKeyPress;
        if (onKeyPress) {
            useOnKeyPress = onKeyPress;
        }
        var InputVariantComponent = inputVariantComponent.standard;
        var FilledInputVariantComponent = inputVariantComponent.filled;
        var OutlinedInputComponent = inputVariantComponent.outlined;
        if (variant === "outlined" && !labelWidth) {
            labelWidth = 60;
        }
        var ref;
        rest.required = (ref = rest === null || rest === void 0 ? void 0 : rest.required) !== null && ref !== void 0 ? ref : validators === null || validators === void 0 ? void 0 : validators.includes("required");
        var starAtEnd = (validators === null || validators === void 0 ? void 0 : validators.includes("required")) ? classes.star : "";
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_FormControl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            variant: "filled",
            fullWidth: true,
            className: containerClass,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_InputLabel__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, inputLabelProps), {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__["default"])(inputLabelProps === null || inputLabelProps === void 0 ? void 0 : inputLabelProps.className, starAtEnd),
                    children: label
                })),
                variant === undefined || variant === "filled" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FilledInputVariantComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, rest), {
                    error: !isValid,
                    onKeyPress: useOnKeyPress
                })) : variant === "outlined" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OutlinedInputComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, rest), {
                    error: !isValid,
                    onKeyPress: useOnKeyPress
                })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputVariantComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, rest), {
                    error: !isValid,
                    onKeyPress: useOnKeyPress
                })),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_FormHelperText__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    id: "weight-helper-text",
                    error: !isValid,
                    children: !isValid && this.getErrorMessage() || helperText
                })
            ]
        });
    };
    return InputValidator;
}(react_form_validator_core__WEBPACK_IMPORTED_MODULE_2__/* .ValidatorComponent */ .nE);
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_3__/* .compose */ .qC)((0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_17__/* .withStyles */ .D)(styles));
/* harmony default export */ __webpack_exports__["ZP"] = (enhance(InputValidator));
var SelectValidator = /*#__PURE__*/ function(ValidatorComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(SelectValidator, ValidatorComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(SelectValidator);
    function SelectValidator() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(this, SelectValidator);
        return _super.apply(this, arguments);
    }
    var _proto = SelectValidator.prototype;
    _proto.render = function render() {
        /* eslint-disable no-unused-vars */ var _props = this.props, error = _props.error, errorMessages = _props.errorMessages, validators = _props.validators, requiredError = _props.requiredError, helperText = _props.helperText, validatorListener = _props.validatorListener, withRequiredValidator = _props.withRequiredValidator, containerClass = _props.containerClass, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_props, [
            "error",
            "errorMessages",
            "validators",
            "requiredError",
            "helperText",
            "validatorListener",
            "withRequiredValidator",
            "containerClass"
        ]);
        var isValid = this.state.isValid;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_FormControl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            variant: "filled",
            fullWidth: true,
            className: containerClass,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, rest), {
                select: true,
                error: !isValid || error,
                helperText: !isValid && this.getErrorMessage() || helperText
            }))
        });
    };
    return SelectValidator;
}(react_form_validator_core__WEBPACK_IMPORTED_MODULE_2__/* .ValidatorComponent */ .nE);
/**
 * Wrap form components in a validator component, that will display the error text, and set a
 * passed in `validClass`/`invalidClass`.
 */ var WrapValidator = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(ValidatorComponent) {
    "use strict";
    _inherits(WrapValidator, ValidatorComponent);
    var _super = _create_super(WrapValidator);
    function WrapValidator() {
        _class_call_check(this, WrapValidator);
        return _super.apply(this, arguments);
    }
    var _proto = WrapValidator.prototype;
    _proto.render = function render() {
        /* eslint-disable no-unused-vars */ var _props = this.props, error = _props.error, errorMessages = _props.errorMessages, validators = _props.validators, requiredError = _props.requiredError, helperText = _props.helperText, validatorListener = _props.validatorListener, withRequiredValidator = _props.withRequiredValidator, containerClass = _props.containerClass, children = _props.children, invalidClass = _props.invalidClass, validClass = _props.validClass, rest = _object_without_properties(_props, [
            "error",
            "errorMessages",
            "validators",
            "requiredError",
            "helperText",
            "validatorListener",
            "withRequiredValidator",
            "containerClass",
            "children",
            "invalidClass",
            "validClass"
        ]);
        var isValid = this.state.isValid;
        var formContainerClass = "".concat(containerClass, " ").concat(isValid ? validClass ? validClass : "" : invalidClass ? invalidClass : "");
        return /*#__PURE__*/ _jsxs(FormControl, {
            variant: "filled",
            fullWidth: true,
            className: formContainerClass,
            children: [
                children,
                /*#__PURE__*/ _jsx(FormHelperText, {
                    id: "weight-helper-text",
                    error: !isValid,
                    children: !isValid && this.getErrorMessage() || helperText
                })
            ]
        });
    };
    return WrapValidator;
}(ValidatorComponent)));
var SelectWithSearchValidator = function(_param) {
    var error = _param.error, errorMessages = _param.errorMessages, helperText = _param.helperText, containerClass = _param.containerClass, optionsArray = _param.optionsArray, onChangeProp = _param.onChangeProp, getOptionSelected = _param.getOptionSelected, filterOptions = _param.filterOptions, selectedValue = _param.selectedValue, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
        "error",
        "errorMessages",
        "helperText",
        "containerClass",
        "optionsArray",
        "onChangeProp",
        "getOptionSelected",
        "filterOptions",
        "selectedValue"
    ]);
    var sortedOptions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(optionsArray).sort(function(a, b) {
            var nameA = a.name.toLowerCase(), nameB = b.name.toLowerCase();
            if (nameA < nameB) {
                //sort string ascending
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    }, [
        optionsArray
    ]);
    var handleChange = function(event, value) {
        if (!value) {
            return;
        }
        onChangeProp(value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_FormControl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        variant: "filled",
        fullWidth: true,
        className: containerClass,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Autocomplete__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
            id: "search-box",
            options: sortedOptions,
            filterOptions: filterOptions,
            getOptionLabel: function(option) {
                return option.name || "";
            },
            onChange: handleChange,
            isOptionEqualToValue: getOptionSelected,
            defaultValue: selectedValue,
            renderInput: function(params) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, params, rest), {
                    error: error,
                    helperText: errorMessages || helperText
                }));
            }
        })
    });
};
var MultiSelectWithSearchValidator = function(_param) {
    var error = _param.error, errorMessages = _param.errorMessages, validators = _param.validators, requiredError = _param.requiredError, helperText = _param.helperText, validatorListener = _param.validatorListener, withRequiredValidator = _param.withRequiredValidator, containerClass = _param.containerClass, optionsArray = _param.optionsArray, onChangeProp = _param.onChangeProp, selectedValue = _param.selectedValue, _multiple = _param.multiple, multiple = _multiple === void 0 ? false : _multiple, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
        "error",
        "errorMessages",
        "validators",
        "requiredError",
        "helperText",
        "validatorListener",
        "withRequiredValidator",
        "containerClass",
        "optionsArray",
        "onChangeProp",
        "selectedValue",
        "multiple"
    ]);
    var isValid = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(Boolean);
    var sortedOptions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(optionsArray).sort(function(a, b) {
            var nameA = a.name.toLowerCase(), nameB = b.name.toLowerCase();
            if (nameA < nameB) {
                //sort string ascending
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    }, [
        optionsArray
    ]);
    var handleChange = function(event, value, _reason) {
        onChangeProp(value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_FormControl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        variant: "filled",
        fullWidth: true,
        className: containerClass,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Autocomplete__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
            multiple: true,
            id: "multi-select",
            options: sortedOptions,
            getOptionLabel: function(option) {
                return option.name;
            },
            defaultValue: selectedValue,
            onChange: handleChange,
            renderInput: function(params) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                    variant: "filled"
                }, params, rest), {
                    error: !isValid || error,
                    helperText: !isValid && errorMessages || helperText
                }));
            }
        })
    });
};


/***/ })

}]);